import get from 'lodash/get';
import includes from 'lodash/includes';
import join from 'lodash/join';
import Assets from './assets';
import { ALLOWED_FORMATS, ALLOWED_EXTENSIONS, MAX_FILE_SIZE } from '../const';

const FORBIDDEN_CHARS = /[|<>\\^]+/;

function validateType(mimeType, resourceType) {
  const isValid = includes(ALLOWED_FORMATS[resourceType], mimeType);

  if (isValid) {
    return false;
  }

  const allowedExtensionsString = join(ALLOWED_EXTENSIONS[resourceType], ', ');
  return {
    title: 'Upload failed',
    subtitle: 'Wrong file format',
    message: `Allowed file formats: ${allowedExtensionsString}`,
  };
}

function validateSize(size, resourceType = 'default') {
  const maxSize = MAX_FILE_SIZE[resourceType];
  const maxSizeString = Assets.convertBytesToMegaBytes(maxSize);
  const isValid = size <= maxSize;

  if (isValid) {
    return false;
  }

  return {
    title: 'Upload failed',
    subtitle: 'File size too big',
    message: `Maximum allowed file size is ${maxSizeString}MB`,
  };
}

function validateFileName(fileName) {
  const containsForbiddenChars = FORBIDDEN_CHARS.test(fileName);
  if (!containsForbiddenChars) {
    return false;
  }
  return {
    title: 'Upload failed',
    message:
      'File name contains forbidden characters. Please remove all of the following: | < > \\ ^',
  };
}

function validate(file, resourceType) {
  const size = get(file, 'size');
  const type = get(file, 'type');
  const fileName = get(file, 'name');

  if (!size || !type) {
    return {
      title: 'Upload failed',
      subtitle: 'File not supported',
      message: 'Please select a different file to upload.',
    };
  }

  const error =
    validateType(type, resourceType) ||
    validateSize(size, resourceType) ||
    validateFileName(fileName);

  if (!error) {
    return false;
  }

  return error;
}

export default {
  validate,
};
